import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTrophy, FaShoppingBag, FaHome, FaUser, FaFutbol } from 'react-icons/fa';

const NAV_ITEMS = [
  { path: '/',            label: 'Accueil',    Icon: FaHome },
  { path: '/leaderboard', label: 'Classement', Icon: FaTrophy },
  { path: '/quiz',        label: 'Jouer',      Icon: FaFutbol,  main: true },
  { path: '/shop',        label: 'Boutique',   Icon: FaShoppingBag },
  { path: '/profile/me',  label: 'Profil',     Icon: FaUser },
];

/**
 * Navigation du bas (tabs mobiles)
 */
function BottomNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div
      className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] z-50"
      style={{
        background: 'linear-gradient(to top, #0a2015, #0d2b1a)',
        borderTop: '1px solid rgba(255,255,255,0.1)',
        paddingBottom: 'env(safe-area-inset-bottom)',
      }}
    >
      <div className="flex items-end justify-around px-2 py-2">
        {NAV_ITEMS.map(({ path, label, Icon, main }) => {
          const active = isActive(path);

          if (main) {
            return (
              <motion.button
                key={path}
                onClick={() => navigate(path)}
                whileTap={{ scale: 0.9 }}
                className="flex flex-col items-center -mt-6"
              >
                <div
                  className="w-14 h-14 rounded-full flex items-center justify-center shadow-lg"
                  style={{
                    background: 'linear-gradient(135deg, #f0b429, #d4920a)',
                    boxShadow: '0 4px 20px rgba(240,180,41,0.5)',
                  }}
                >
                  <Icon size={22} className="text-black" />
                </div>
                <span
                  className="text-qfl-gold text-xs font-bold mt-1"
                  style={{ fontFamily: "'Rajdhani', sans-serif" }}
                >
                  {label}
                </span>
              </motion.button>
            );
          }

          return (
            <motion.button
              key={path}
              onClick={() => navigate(path)}
              whileTap={{ scale: 0.9 }}
              className="flex flex-col items-center gap-1 py-1 px-2"
            >
              <div className="relative">
                <Icon
                  size={18}
                  className={`transition-colors duration-200 ${active ? 'text-qfl-gold' : 'text-white/40'}`}
                />
                {active && (
                  <motion.div
                    layoutId="nav-indicator"
                    className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-qfl-gold"
                  />
                )}
              </div>
              <span
                className={`text-xs font-semibold transition-colors duration-200 ${active ? 'text-qfl-gold' : 'text-white/40'}`}
                style={{ fontFamily: "'Rajdhani', sans-serif" }}
              >
                {label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </div>
  );
}

export default BottomNav;
